import { toast } from '@appd/uik';
import { Template } from '../hooks/TemplateListModel';
import { validateTemplates, logger } from '.';

enum MessageType {
  RESERVED = 'Reserved',
  DUPLICATE = 'Duplicate',
}

export const validateAndNotifyTemplateDuplicates = (templateList: Template[]): void => {
  const {
    error: { duplicates, reserved },
  } = validateTemplates(templateList);

  const generateMessage = (items: string[], type: MessageType) => {
    const plural = items.length > 1 ? 'names' : 'name';
    return `${type} dashboard ${plural} found: ${items.map(name => `'${name}'`).join(', ')}`;
  };

  const showMessage = (items: string[], type: MessageType) => {
    const message = generateMessage(items, type);
    toast({
      copy: false,
      description: message,
      icon: 'ERROR',
      title: type,
    });
    logger.warn(message);
  };

  if (reserved.length > 0) {
    showMessage(reserved, MessageType.RESERVED);
  }

  if (duplicates.length > 0) {
    showMessage(duplicates, MessageType.DUPLICATE);
  }
};
